interface InsurancePayerIpa {
  payer: string;
  ipa: string | null;
}

const CONFLUENT_INSURANCE_PAYER_IPA: Record<string, InsurancePayerIpa> = {
  "6 Degrees Health - CA": { payer: "6 Degrees Health", ipa: null },
  "90 Degree Benefits - CA": { payer: "90 Degree Benefits", ipa: null },
  "AAA American Automobile Assc MVA - CA": { payer: "AAA", ipa: null },
  "AARP MC Supp - CA": { payer: "UHC", ipa: null },
  "AARP MCR Adv - CA": { payer: "UHC", ipa: null },
  "Acclaim Risk Managment WC - CA": { payer: "Acclaim Risk Managment WC", ipa: null },
  "Ace American Ins Co - CA": { payer: "Ace American Ins Co", ipa: null },
  "Acuity Group Concierge - CA": { payer: "Acuity Group Concierge", ipa: null },
  "ACWA/JPIA WC - CA": { payer: "ACWA/JPIA WC", ipa: null },
  "Admin One LLC - CA": { payer: "Admin One LLC", ipa: null },
  "Administrative Concepts - CA": { payer: "Administrative Concepts", ipa: null },
  "Adminsure WC - CA": { payer: "Adminsure WC", ipa: null },
  "Aetna - CA": { payer: "Aetna", ipa: null },
  "Aetna Better Health of CA": { payer: "Aetna", ipa: null },
  "Aetna MCR Adv - CA": { payer: "Aetna", ipa: null },
  "Aetna Senior MC Supp - CA": { payer: "Aetna", ipa: null },
  "Affiliated Partners IPA - CA": { payer: "Affiliated Partners", ipa: "Affiliated Partners" },
  "A-G Administrators - CA": { payer: "A-G Administrators", ipa: null },
  "Aither Health - CA": { payer: "Aither Health", ipa: null },
  "Alaska National Insurance WC - CA": { payer: "Alaska National Insurance WC", ipa: null },
  "Alignment Health Plan - CA": { payer: "Alignment", ipa: null },
  "All Savers UHC - CA": { payer: "All Savers", ipa: null },
  "All State Health MC Supp - CA": { payer: "All State Health", ipa: null },
  "All State MVA - CA": { payer: "All State", ipa: null },
  "All United Med Grp - Alignment - CA": { payer: "Alignment", ipa: "All United" },
  "All United Med Grp Brand New Day - CA": { payer: "Brand New Day", ipa: "All United" },
  "All United Med Grp Central Health Plan - CA": { payer: "Central Health Plan", ipa: "All United" },
  "All United Med Grp Choice Physician- CA": { payer: "Choice Physicians Network", ipa: "All United" },
  "All United Med Grp SCAN - CA": { payer: "SCAN", ipa: "All United" },
  "All United Med Grp UHC - CA": { payer: "UHC", ipa: "All United" },
  "Allegiance Benefit Plan - CA": { payer: "Allegiance Benefit Plan", ipa: null },
  "Allied Benefit Systems Cigna - CA": { payer: "Allied Benefit Systems", ipa: null },
  "Allied Benefits Systems Aetna - CA": { payer: "Allied Benefit Systems", ipa: null },
  "Allied Managed Care WC - CA": { payer: "Allied Managed Care WC", ipa: null },
  "Allied National / Zellis - CA": { payer: "Allied National / Zellis", ipa: null },
  "Allied Pacific of California (IPA) - CA": {
    payer: "Allied Pacific of California (IPA)",
    ipa: "Allied Pacific of California (IPA)",
  },
  "Alpha Care - Alignment - CA": { payer: "Alignment", ipa: "Alpha Care" },
  "Alpha Care - CA": { payer: "Alpha Care", ipa: "Alpha Care" },
  "Alpha Care - SCAN - CA": { payer: "SCAN", ipa: "Alpha Care" },
  "Alpha Care Aetna - CA": { payer: "Aetna", ipa: "Alpha Care" },
  "Alpha Care Blue Cross - CA": { payer: "Blue Cross", ipa: "Alpha Care" },
  "Alpha Care Blue Cross MCR Adv - CA": { payer: "Blue Cross", ipa: "Alpha Care" },
  "Alpha Care Blue Shield - CA": { payer: "Blue Shield", ipa: "Alpha Care" },
  "Alpha Care Brand New Day - CA": { payer: "Brand New Day", ipa: "Alpha Care" },
  "Alpha Care Health Net - CA": { payer: "Health Net", ipa: "Alpha Care" },
  "Alpha Care IEHP - CA": { payer: "IEHP", ipa: "Alpha Care" },
  "Alpha Care Molina - CA": { payer: "Molina", ipa: "Alpha Care" },
  "AMA Insurance Agency - CA": { payer: "AMA Insurance Agency", ipa: null },
  "AmeriBen Solutions Inc - CA": { payer: "AmeriBen Solutions Inc", ipa: null },
  "American Claims Management - CA": { payer: "American Claims Management", ipa: null },
  "American Equity Underwriters WC - CA": { payer: "American Equity Underwriters WC", ipa: null },
  "American Health Resources MCR Supp - CA": { payer: "American Health Resources", ipa: null },
  "American Maritime Officers MC Supp - CA": { payer: "American Maritime Officers", ipa: null },
  "American National MC Supp - CA": { payer: "American National", ipa: null },
  "American Primary Care IPA - CA": { payer: "American Primary Care", ipa: "American Primary Care" },
  "American Republic Insurance - CA": { payer: "American Republic Insurance", ipa: null },
  "American Risk WC - CA": { payer: "American Risk WC", ipa: null },
  "American Speciality Health Networks (ASH) - CA": { payer: "American Speciality Health Networks (ASH)", ipa: null },
  "Amerigroup - CA": { payer: "Amerigroup", ipa: null },
  "AMG IPA OON - CA": { payer: "AMG IPA", ipa: "AMG IPA" },
  "AMLJIA WC - CA": { payer: "AMLJIA WC", ipa: null },
  "Amtrust N America WC - CA": { payer: "Amtrust N America WC", ipa: null },
  "Apricus WC - CA": { payer: "Apricus WC", ipa: null },
  "APWU - CA": { payer: "APWU", ipa: null },
  "Arch Healthpartners/Sharp/SCMG - CA": { payer: "Arch Healthpartners/Sharp/SCMG", ipa: null },
  "Assoc Hispanic Physicians of SO CA - CA": {
    payer: "Assoc Hispanic Physicians of SO CA",
    ipa: "Assoc Hispanic Physicians of SO CA",
  },
  "Asuris NW Health - CA": { payer: "Asuris NW Health", ipa: null },
  "Athens Admin WC - CA": { payer: "Athens Admin WC", ipa: null },
  "Atrio Health Plan MCR Adv - CA": { payer: "Atrio Health Plan", ipa: null },
  "Auxiant - CA": { payer: "Auxiant", ipa: null },
  "Bankers Fidelity MCR Supp - CA": { payer: "Bankers Fidelity", ipa: null },
  "Bankers Life MC Supp - CA": { payer: "Bankers Life", ipa: null },
  "Bardavon WC - CA": { payer: "Bardavon WC", ipa: null },
  "Bella Vista MG - CA": { payer: "Bella Vista", ipa: "Bella Vista" },
  "Bella Vista MG Molina - CA": { payer: "Molina", ipa: "Bella Vista" },
  "Benchmark Administrators WC - CA": { payer: "Benchmark Administrators WC", ipa: null },
  "Benefit Advantage - CA": { payer: "Benefit Advantage", ipa: null },
  "Benefit Health Plan, Inc - CA": { payer: "Benefit Health Plan, Inc", ipa: null },
  "Benefit Plan Administrators - CA": { payer: "Benefit Plan Administrators", ipa: null },
  "Benefit Risk Management PPO - CA": { payer: "Benefit Risk Management PPO", ipa: null },
  "Benefit Risk Managment WC - CA": { payer: "Benefit Risk Managment WC", ipa: null },
  "BerkleyNet WC - CA": { payer: "BerkleyNet WC", ipa: null },
  "Berkshire Hathaway Guard WC - CA": { payer: "Berkshire Hathaway Guard WC", ipa: null },
  "Berkshire Hathaway Homestate THM WC - CA": { payer: "Berkshire Hathaway Homestate THM WC", ipa: null },
  "Berkshire Hathaway WC - CA": { payer: "Berkshire Hathaway WC", ipa: null },
  "Beta Healthcare WC - CA": { payer: "Beta Healthcare WC", ipa: null },
  "Biberk Insurance WC - CA": { payer: "Biberk Insurance WC", ipa: null },
  "Blackhawk Claims Service - CA": { payer: "Blackhawk Claims Service", ipa: null },
  "Blue Cross (All Star) - CA": { payer: "Blue Cross", ipa: null },
  "Blue Cross MCR Adv - CA": { payer: "Blue Cross", ipa: null },
  "Blue Shield (All Star) - CA": { payer: "Blue Shield", ipa: null },
  "Blue Shield MCR Adv (All Star) - CA": { payer: "Blue Shield", ipa: null },
  "Blue Shield Medi-Cal MCD (All Star) - CA": { payer: "Blue Shield", ipa: null },
  "Blue Shield Promise (All Star) - CA": { payer: "Blue Shield Promise", ipa: null },
  "Blue Star Work Comp - CA": { payer: "Blue Star Work Comp", ipa: null },
  "Blue Zones Health - CA": { payer: "Blue Zones Health", ipa: null },
  "BMI Benefits LLC - CA": { payer: "BMI Benefits LLC", ipa: null },
  "BNSF Railroad Injury Care Work Comp - CA": { payer: "BNSF Railroad Injury Care Work Comp", ipa: null },
  "Boon Chapman - CA": { payer: "Boon Chapman", ipa: null },
  "Brand New Day - CA": { payer: "Brand New Day", ipa: null },
  "Broadspire WC - CA": { payer: "Broadspire WC", ipa: null },
  "Brotherhood Mutual Ins WC - CA": { payer: "Brotherhood Mutual Ins WC", ipa: null },
  "Buenaventura Affiliated Physicians - CA": {
    payer: "Buenaventura Affiliated Physicians",
    ipa: "Buenaventura Affiliated Physicians",
  },
  "CalOptima Direct Secondary OON - CA": { payer: "CalOptima", ipa: null },
  "Can Assistance PMB - CA": { payer: "Can Assistance PMB", ipa: null },
  "Care IQ WC - CA": { payer: "Care IQ WC", ipa: null },
  "Careguard - CA": { payer: "Careguard", ipa: null },
  "Carelon Health - CA": { payer: "Carelon Health", ipa: null },
  "Careworks Work Comp - CA": { payer: "Careworks Work Comp", ipa: null },
  "Catilize Health Insurance - CA": { payer: "Catilize Health Insurance", ipa: null },
  "CBCS Work Comp - CA": { payer: "CBCS Work Comp", ipa: null },
  "CCMSI WC - CA": { payer: "CCMSI WC", ipa: null },
  "Cedar Sinai General - CA": { payer: "Cedars-Sinai Medical Group", ipa: "Cedars-Sinai Medical Group" },
  "Cedar Sinai Pediatrics - CA": { payer: "Cedars-Sinai Medical Group", ipa: "Cedars-Sinai Medical Group" },
  "Cedar Sinai Seniors - CA": { payer: "Cedars-Sinai Medical Group", ipa: "Cedars-Sinai Medical Group" },
  "Cedar Sinai Women's Health - CA": { payer: "Cedars-Sinai Medical Group", ipa: "Cedars-Sinai Medical Group" },
  "Center IPA - CA": { payer: "Center IPA", ipa: "Center IPA" },
  "Centinela Valley IPA (PTPN) - CA": { payer: "Centinela Valley", ipa: "Centinela Valley" },
  "Central Health Plan / AUMG - CA": { payer: "Central Health Plan", ipa: "AUMG" },
  "CHAMP VA - CA": { payer: "CHAMP VA", ipa: null },
  "Charles Taylor TPA WC - CA": { payer: "Charles Taylor TPA WC", ipa: null },
  "Choice Physicians Network - CA": { payer: "Choice Physicians Network", ipa: "Choice Physicians Network" },
  "Choice Physicians Network-Alignment - CA": { payer: "Alignment", ipa: "Choice Physicians Network" },
  "Choice Physicians Network-Blue Cross - CA": { payer: "Blue Cross", ipa: "Choice Physicians Network" },
  "Choice Physicians Network-Health Net - CA": { payer: "Health Net", ipa: "Choice Physicians Network" },
  "Choice Physicians Network-Humana - CA": { payer: "Humana", ipa: "Choice Physicians Network" },
  "Choice Physicians Network-Scan - CA": { payer: "SCAN", ipa: "Choice Physicians Network" },
  "Choice Physicians Network-UHC - CA": { payer: "UHC", ipa: "Choice Physicians Network" },
  "Christian Brother Services - CA": { payer: "Christian Brother Services", ipa: null },
  "Chubb WC - CA": { payer: "Chubb WC", ipa: null },
  "Church Mutual WC - CA": { payer: "Church Mutual WC", ipa: null },
  "Cigna - CA": { payer: "Cigna", ipa: null },
  "City of Anaheim WC - CA": { payer: "City of Anaheim WC", ipa: null },
  "City Of Long Beach WC - CA": { payer: "City Of Long Beach WC", ipa: null },
  "City of San Diego WC - CA": { payer: "City of San Diego WC", ipa: null },
  "City Of Santa Monica WC - CA": { payer: "City Of Santa Monica WC", ipa: null },
  "Claim Quest WC - CA": { payer: "Claim Quest WC", ipa: null },
  "ClearComp Work Comp - CA": { payer: "ClearComp Work Comp", ipa: null },
  "Clearwater Benefits Admin - CA": { payer: "Clearwater Benefits Admin", ipa: null },
  "Clever Care Health Plan - CA": { payer: "Clever Care Health Plan", ipa: null },
  "CMC Gallagher Basset WC - CA": { payer: "CMC Gallagher Basset WC", ipa: null },
  "CNA Insurance Work Comp - CA": { payer: "CNA Insurance Work Comp", ipa: null },
  "CoachellaMed - CA": { payer: "CoachellaMed", ipa: "CoachellaMed" },
  "CoachellaMed -Alignment - CA": { payer: "Alignment", ipa: "CoachellaMed" },
  "CoachellaMed SCAN - CA": { payer: "SCAN", ipa: "CoachellaMed" },
  "CoachellaMed UHC - CA": { payer: "UHC", ipa: "CoachellaMed" },
  "Coeur - CA": { payer: "Coeur", ipa: null },
  "Colonial Penn Life Insurance - CA": { payer: "Colonial Penn Life Insurance", ipa: null },
  "Combined Insurance MC Supp - CA": { payer: "Combined Insurance", ipa: null },
  "Community Care IPA - CA": { payer: "Community Care", ipa: "Community Care" },
  "Community Care IPA-Molina - CA": { payer: "Molina", ipa: "Community Care" },
  "Community Family Care Med Group - CA": { payer: "Community Family Care", ipa: "Community Family Care" },
  "Community Health Group - CA": { payer: "Community Health Group", ipa: null },
  "Community Health Group MCR Adv - CA": { payer: "Community Health Group", ipa: null },
  "Community Health Group Medi-Cal OON": { payer: "Community Health Group", ipa: null },
  "Comp Direct SCE PTPN WC - CA": { payer: "Comp SCE PTPN WC", ipa: null },
  "Compass Pilot WC - CA": { payer: "Compass Pilot WC", ipa: null },
  "Compwest WC - CA": { payer: "Compwest WC", ipa: null },
  "Conduent WC - CA": { payer: "Conduent WC", ipa: null },
  "Convergence Care WC - CA": { payer: "Convergence Care WC", ipa: null },
  "Coordinated Benefit Plans - CA": { payer: "Coordinated Benefit Plans", ipa: null },
  "Copperpoint WC - CA": { payer: "Copperpoint WC", ipa: null },
  "Cornerstone Preferred Resources - CA": { payer: "Cornerstone Preferred Resources", ipa: null },
  "Corvel WC - CA": { payer: "Corvel WC", ipa: null },
  "Country Life MC Supp - CA": { payer: "Country Life", ipa: null },
  "County Of Riverside WC - CA": { payer: "County Of Riverside WC", ipa: null },
  "County of San Diego WC - CA": { payer: "County of San Diego WC", ipa: null },
  "CPN-Brilla Star Medical Group - CA": { payer: "CPN-Brilla Star", ipa: "CPN-Brilla Star" },
  "CPN-Brilla Star Medical Group - IEHP - CA": { payer: "IEHP", ipa: "CPN-Brilla Star" },
  "CPN-Brilla Star Medical Group - SCAN - CA": { payer: "SCAN", ipa: "CPN-Brilla Star" },
  "CPN-Brilla Star Medical Group -SCAN - CA": { payer: "SCAN", ipa: "CPN-Brilla Star" },
  "Crum & Forster Work Comp - CA": { payer: "Crum & Forster Work Comp", ipa: null },
  "Curative - CA": { payer: "Curative", ipa: null },
  "Desert Oasis Healthcare - Aetna - CA": { payer: "Aetna", ipa: "Desert Oasis Healthcare" },
  "Desert Oasis Healthcare - Alignment - CA": { payer: "Alignment", ipa: "Desert Oasis Healthcare" },
  "Desert Oasis Healthcare - Blue Cross - CA": { payer: "Blue Cross", ipa: "Desert Oasis Healthcare" },
  "Desert Oasis Healthcare - CA": { payer: "Desert Oasis Healthcare", ipa: "Desert Oasis Healthcare" },
  "Desert Oasis Healthcare - Health Net - CA": { payer: "Health Net", ipa: "Desert Oasis Healthcare" },
  "Desert Oasis Healthcare - Humana - CA": { payer: "Humana", ipa: "Desert Oasis Healthcare" },
  "Desert Oasis Healthcare - IEHP - CA": { payer: "IEHP", ipa: "Desert Oasis Healthcare" },
  "Desert Oasis Healthcare - SCAN - CA": { payer: "SCAN", ipa: "Desert Oasis Healthcare" },
  "Desert Oasis Healthcare - WELLCARE - CA": { payer: "WellCare", ipa: "Desert Oasis Healthcare" },
  "Desert Oasis Healthcare Blue Cross MCR Adv - CA": { payer: "Blue Cross", ipa: "Desert Oasis Healthcare" },
  "Desert Oasis Healthcare Blue Shield - CA": { payer: "Blue Shield", ipa: "Desert Oasis Healthcare" },
  "Desert Oasis Healthcare Molina - CA": { payer: "Molina", ipa: "Desert Oasis Healthcare" },
  "Desert Oasis Healthcare United Healthcare - CA": { payer: "UHC", ipa: "Desert Oasis Healthcare" },
  "Detego Health - CA": { payer: "Detego Health", ipa: null },
  "Devoted Health MCR Adv - CA": { payer: "Devoted Health", ipa: null },
  "East West Administrators - CA": { payer: "East West Administrators", ipa: null },
  "EBA&M - CA": { payer: "EBA&M", ipa: null },
  "EBMS - CA": { payer: "EBMS", ipa: null },
  "EDIS - CA": { payer: "EDIS", ipa: null },
  "EK Health WC - CA": { payer: "EK Health WC", ipa: null },
  "El Proyecto del Barrio - CA": { payer: "El Proyecto del Barrio", ipa: "El Proyecto del Barrio" },
  "El Proyecto del Barrio Blue Cross - CA": { payer: "Blue Cross", ipa: "El Proyecto del Barrio" },
  "El Proyecto del Barrio Blue Cross MCR Adv - CA": { payer: "Blue Cross", ipa: "El Proyecto del Barrio" },
  "El Proyecto del Barrio Blue Shield - CA": { payer: "Blue Shield", ipa: "El Proyecto del Barrio" },
  "El Proyecto del Barrio Health Net - CA": { payer: "Health Net", ipa: "El Proyecto del Barrio" },
  "El Proyecto del Barrio LA Care - CA": { payer: "LA Care", ipa: "El Proyecto del Barrio" },
  "Elite Health Plan MCR Adv - CA": { payer: "Elite Health Plan", ipa: null },
  "Emblem Health - CA": { payer: "Emblem Health", ipa: null },
  "Empire Healthcare IPA - CA": { payer: "Empire Healthcare", ipa: "Empire Healthcare" },
  "Empire Healthcare IPA -Alignment - CA": { payer: "Alignment", ipa: "Empire Healthcare" },
  "Empire Plan - CA": { payer: "Empire Plan", ipa: null },
  "Employee Financial Class - CA": { payer: "Employee Financial Class", ipa: null },
  "Employers Assurance Co WC - CA": { payer: "Employers Assurance Co WC", ipa: null },
  "ESIS WC - CA": { payer: "ESIS WC", ipa: null },
  "Everence MC Supp - CA": { payer: "Everence", ipa: null },
  "Exclusive Care (All Star) - CA": { payer: "Exclusive Care", ipa: null },
  "Family Care Specialists IPA - CA": { payer: "Family Care Specialists", ipa: "Family Care Specialists" },
  "Family Practice Med Grp OON - CA": { payer: "Family Practice Med Grp", ipa: "Family Practice Med Grp" },
  "Farmers Ins MVA - CA": { payer: "Farmers Ins", ipa: null },
  "Fenix Medical Group - CA": { payer: "Fenix", ipa: "Fenix" },
  "FH - 100% Reduction - CA": { payer: "FH - 100% Reduction", ipa: null },
  "FH - 50% Reduction - CA": { payer: "FH - 50% Reduction", ipa: null },
  "First Choice Health - CA": { payer: "First Choice Health", ipa: null },
  "Fontana Unified School District WC - CA": { payer: "Fontana Unified School District WC", ipa: null },
  "Foreign Service Benefit Plan - CA": { payer: "Foreign Service Benefit Plan", ipa: null },
  "Fresno State Sports Insurance - CA": { payer: "Fresno State Sports Insurance", ipa: null },
  "Gallagher Bassett WC - CA": { payer: "Gallagher Bassett WC", ipa: null },
  "GCU-Greek Catholic Union - CA": { payer: "GCU-Greek Catholic Union", ipa: null },
  "GEHA UHC - CA": { payer: "UMR", ipa: null },
  "Geico MVA - CA": { payer: "Geico", ipa: null },
  "Global Care Medical Group - CA": { payer: "Global Care", ipa: "Global Care" },
  "Global Excel Management Inc - CA": { payer: "Global Excel Management Inc", ipa: null },
  "Global Sports Services WC - CA": { payer: "Global Sports Services WC", ipa: null },
  "Globe Life And Accident Ins CO - CA": { payer: "Globe Life And Accident Ins CO", ipa: null },
  "Golden Physicians Med Grp - CA": { payer: "Golden Physicians", ipa: "Golden Physicians" },
  "Gravie Admin Services - CA": { payer: "Gravie Admin Services", ipa: null },
  "Great Southern Life MC Supp - CA": { payer: "Great Southern Life", ipa: null },
  "Great States Health Admin - CA": { payer: "Great States Health Admin", ipa: null },
  "Greater Tri-Cities - CA": { payer: "Greater Tri-Cities", ipa: null },
  "Guide One WC - CA": { payer: "Guide One WC", ipa: null },
  "Hartford Group Retirement Plan - CA": { payer: "Hartford Group Retirement Plan", ipa: null },
  "Harvard Pilgrim Health Care - CA": { payer: "Harvard Pilgrim Health Care", ipa: null },
  "Health Care LA IPA - CA": { payer: "Health Care LA", ipa: "Health Care LA" },
  "Health Care LA IPA Alignment - CA": { payer: "Alignment", ipa: "Health Care LA" },
  "Health Care LA IPA Blue Cross - CA": { payer: "Blue Cross", ipa: "Health Care LA" },
  "Health Care LA IPA Blue Cross MCR Adv - CA": { payer: "Blue Cross", ipa: "Health Care LA" },
  "Health Care LA IPA Blue Shield - CA": { payer: "Blue Shield", ipa: "Health Care LA" },
  "Health Care LA IPA Health Net - CA": { payer: "Health Net", ipa: "Health Care LA" },
  "Health Care LA IPA LA Care - CA": { payer: "LA Care", ipa: "Health Care LA" },
  "Health Care LA IPA Molina - CA": { payer: "Molina", ipa: "Health Care LA" },
  "Health Excel IPA  Aetna - CA": { payer: "Aetna", ipa: "Health Excel" },
  "Health Excel IPA - CA": { payer: "Health Excel", ipa: "Health Excel" },
  "Health Excel IPA Blue Cross - CA": { payer: "Blue Cross", ipa: "Health Excel" },
  "Health Excel IPA Blue Cross MCR Adv - CA": { payer: "Blue Cross", ipa: "Health Excel" },
  "Health Excel IPA Blue Shield - CA": { payer: "Blue Shield", ipa: "Health Excel" },
  "Health Excel IPA HUMANA - CA": { payer: "Humana", ipa: "Health Excel" },
  "Health Excel IPA SCAN - CA": { payer: "SCAN", ipa: "Health Excel" },
  "Health EZ / Aetna PPO - CA": { payer: "HealthEZ", ipa: null },
  "Health First TPA - CA": { payer: "Health First TPA", ipa: null },
  "Health Net Direct - CA": { payer: "Health Net", ipa: null },
  "Health Net MC Supp - CA": { payer: "Health Net", ipa: null },
  "Health Net Medi-Cal MCD - CA": { payer: "Health Net", ipa: null },
  "Health Options Program MC Supp - CA": { payer: "Health Options Program", ipa: null },
  "Health Plans Inc - ID": { payer: "Health Plans Inc", ipa: null },
  "Health Special Risk Inc - CA": { payer: "Health Special Risk Inc", ipa: null },
  "Healthcomp - CA": { payer: "Healthcomp", ipa: null },
  "HealthPartners Claims - CA": { payer: "HealthPartners Claims", ipa: null },
  "Healthscope Benefits Inc - CA": { payer: "Healthscope Benefits Inc", ipa: null },
  "Healthspring MC Supp": { payer: "HealthSpring", ipa: null },
  "HealthSpring MCR Adv OON": { payer: "HealthSpring", ipa: null },
  "Helmsman Management Claims WC - CA": { payer: "Helmsman Management Claims WC", ipa: null },
  "Heritage Victor Valley Med Group - CA": { payer: "Heritage Victor Valley", ipa: "Heritage Victor Valley" },
  "Hinge Health - CA": { payer: "Hinge Health", ipa: null },
  "Homelink WC (All Star) - CA": { payer: "Homelink WC", ipa: null },
  "Homeport Insurance WC - CA": { payer: "Homeport Insurance WC", ipa: null },
  "Hoover Health Systems Work Comp - CA": { payer: "Hoover Health Systems Work Comp", ipa: null },
  "HPN / Sierra Health and Life - CA": { payer: "HPN / Sierra Health and Life", ipa: null },
  "Humana - CA": { payer: "Humana", ipa: null },
  "Humana MCR Adv - CA": { payer: "Humana", ipa: null },
  "IAC Life MC Supp - CA": { payer: "IAC Life", ipa: null },
  "ICW Insurance Co of the West WC - CA": { payer: "ICW Insurance Co of the West WC", ipa: null },
  "IEHP COVERED - CA": { payer: "IEHP", ipa: null },
  "IEHP MCD - CA": { payer: "IEHP", ipa: null },
  "IEHP MCR Adv - CA": { payer: "IEHP", ipa: null },
  "ILWU-PMA Zenith American - CA": { payer: "ILWU-PMA Zenith American", ipa: null },
  "Imagine 360 / GPA- CA": { payer: "Imagine 360 / GPA", ipa: null },
  "Imperial Health Holdings Medical Group - CA": { payer: "Imperial Health", ipa: "Imperial Health" },
  "Imperial Health Holdings Medical Group Blue Cross MCR Adv -CA": {
    payer: "Blue Cross",
    ipa: "Imperial Health Holdings",
  },
  "Imperial Health Holdings Medical Group Blue Cross-CA": { payer: "Blue Cross", ipa: "Imperial Health Holdings" },
  "Imperial Health Holdings Medical Group Blue Shield-CA": { payer: "Blue Shield", ipa: "Imperial Health Holdings" },
  "Imperial Insurance Companies - CA": { payer: "Imperial Insurance Companies", ipa: null },
  "Indian Health - Riverside/San Bernadino County - CA": {
    payer: "Indian Health - Riverside/San Bernadino County",
    ipa: null,
  },
  "Indian Health Council - CA": { payer: "Indian Health Council", ipa: null },
  "Innovative Claim Solutions WC - CA": { payer: "Innovative Claim Solutions WC", ipa: null },
  "Inova Care - CA": { payer: "Inova Care", ipa: null },
  "Intact Insurance Specialty Solutions WC - CA": { payer: "Intact Insurance Specialty Solutions WC", ipa: null },
  "Integrated Health Partners - CA": { payer: "Integrated Health Partners", ipa: "Integrated Health Partners" },
  "Integrated Health Partners Blue Shield - CA": { payer: "Blue Shield", ipa: "Integrated Health Partners" },
  "Intercare WC - CA": { payer: "Intercare WC", ipa: null },
  "InterMed Cost Containment Work Comp - CA": { payer: "InterMed Cost Containment Work Comp", ipa: null },
  "Intermountain Claims Work Comp - CA": { payer: "Intermountain Claims Work Comp", ipa: null },
  "International Medical Group INC - CA": {
    payer: "International Medical Group INC",
    ipa: "International Medical Group INC",
  },
  "ION PT WC - CA": { payer: "ION PT WC", ipa: null },
  "Iron Road MC Supp - CA": { payer: "Iron Road", ipa: null },
  "Kaiser (All Star) - CA": { payer: "Kaiser", ipa: null },
  "Kaiser (All Star) MCR Adv - CA": { payer: "Kaiser", ipa: null },
  "Kaiser (All Star) Medi-Cal  MCD - CA": { payer: "Kaiser", ipa: null },
  "Kaiser Colorado - CA": { payer: "Kaiser", ipa: null },
  "Kaiser Foundation of Hawaii - CA": { payer: "Kaiser", ipa: null },
  "Kaiser Mid-Atlantic States - CA": { payer: "Kaiser", ipa: null },
  "Kaiser National Claims - GA": { payer: "Kaiser", ipa: null },
  "Kaiser Northern - CA": { payer: "Kaiser", ipa: null },
  "Kaiser Northwest - CA": { payer: "Kaiser", ipa: null },
  "Kaiser Permanente Insurance - CA": { payer: "Kaiser", ipa: null },
  "Kaiser Permanente KPIC - CA": { payer: "Kaiser", ipa: null },
  "Kaiser Permanente Washington - CA": { payer: "Kaiser", ipa: null },
  "Kaiser Riverside - CA": { payer: "Kaiser", ipa: null },
  "Kaiser Riverside MCR Adv - CA": { payer: "Kaiser", ipa: null },
  "Kaiser Riverside Medi-Cal MCD - CA": { payer: "Kaiser", ipa: null },
  "Kaiser WC - CA": { payer: "Kaiser WC", ipa: null },
  "Keenan & Assoc WC - CA": { payer: "Keenan & Assoc WC", ipa: null },
  "Keenan Associates / Prime Healthcare - CA": { payer: "Keenan Associates / Prime Healthcare", ipa: null },
  "Kemper Services Group MVA - CA": { payer: "Kemper Services Group", ipa: null },
  "Kern Family Healthcare MCD - CA": { payer: "Kern Family Healthcare", ipa: null },
  "Key Health Medical - CA": { payer: "Key Health Medical", ipa: null },
  "Key Solution - CA": { payer: "Key Solution", ipa: null },
  "LA Care Health Plan - CA": { payer: "LA Care", ipa: null },
  "La Salle Medical /Altura - SCAN - CA": { payer: "SCAN", ipa: "La Salle Medical /Altura" },
  "La Salle Medical/Altura - Blue Cross - CA": { payer: "Blue Cross", ipa: "La Salle Medical/Altura" },
  "La Salle Medical/Altura - Blue Cross MCR Adv - CA": { payer: "Blue Cross", ipa: "La Salle Medical/Altura" },
  "La Salle Medical/Altura - CA": { payer: "La Salle Medical/Altura", ipa: "La Salle Medical/Altura" },
  "La Salle Medical/Altura - IEHP - CA": { payer: "IEHP", ipa: "La Salle Medical/Altura" },
  "La Salle Medical/Altura - Molina - CA": { payer: "Molina", ipa: "La Salle Medical/Altura" },
  "Lakeside Community Healthcare - CA": {
    payer: "Lakeside Community Healthcare",
    ipa: "Lakeside Community Healthcare",
  },
  "Liberty Healthshare - CA": { payer: "Liberty Healthshare", ipa: null },
  "Liberty Mutual MVA - CA": { payer: "Liberty Mutual", ipa: null },
  "Liberty Mutual WC - CA": { payer: "Liberty Mutual WC", ipa: null },
  "Live Well IPA - CA": { payer: "Live Well", ipa: "Live Well" },
  "Live Well IPA SCAN - CA": { payer: "SCAN", ipa: "Live Well" },
  "Loma Linda Risk Management Commercial OON - CA": { payer: "Loma Linda Risk Management Commercial", ipa: null },
  "Loma Linda Risk Mgmt WC - CA": { payer: "Loma Linda Risk Mgmt WC", ipa: null },
  "Los Angeles County MTA WC - CA": { payer: "Los Angeles County MTA WC", ipa: null },
  "Loyal American Life MC Supp - CA": { payer: "Loyal American Life", ipa: null },
  "Lucent Health / North America Administrators - CA": {
    payer: "Lucent Health / North America Administrators",
    ipa: null,
  },
  "Lucent Health Ins - CA": { payer: "Lucent Health Ins", ipa: null },
  "Lumico MCR Supp - CA": { payer: "Lumico", ipa: null },
  "Luminaire Health - CA": { payer: "Luminaire Health", ipa: null },
  "LWP Claims Solutions WC - CA": { payer: "LWP Claims Solutions WC", ipa: null },
  "Magnacare MC Supp - CA": { payer: "Magnacare", ipa: null },
  "ManageWare Solutions Work Comp - CA": { payer: "ManageWare Solutions Work Comp", ipa: null },
  "Manhattan Life MC Supp - CA": { payer: "Manhattan Life", ipa: null },
  "Marpai Health - CA": { payer: "Marpai Health", ipa: null },
  "MCD Secondary Dual Plans - CA": { payer: "", ipa: null },
  "MD Senior Care Med Group - CA": { payer: "MD Senior Care", ipa: "MD Senior Care" },
  "MD Senior Care Med Group SCAN - CA": { payer: "SCAN", ipa: "MD Senior Care" },
  "Med Solutions International Work Comp - CA": { payer: "Med Solutions International Work Comp", ipa: null },
  "Medica Government Programs - CA": { payer: "Medica Government Programs", ipa: null },
  "Medica Health Plan - CA": { payer: "Medica Health Plan", ipa: null },
  "Medi-Cal - CA": { payer: "Medi-Cal", ipa: null },
  "Medical Lien": { payer: "Medical Lien", ipa: null },
  "Medical Mutual - CA": { payer: "Medical Mutual", ipa: null },
  "Medical Records - CA": { payer: "Medical Records", ipa: null },
  "Medicare B (North) (All Star) - CA": { payer: "Medicare", ipa: null },
  "Medicare B (South) (All Star) - CA": { payer: "Medicare", ipa: null },
  "Medico MC Supp - CA": { payer: "Medico", ipa: null },
  "Mediplus - CA": { payer: "Mediplus", ipa: null },
  "Medi-Share - CA": { payer: "Medi-Share", ipa: null },
  "Medivest - CA": { payer: "Medivest", ipa: null },
  "MedRisk WC (All Star) - CA": { payer: "MedRisk WC", ipa: null },
  "Mercury Insurance Group MVA - CA": { payer: "Mercury Insurance Group", ipa: null },
  "Mercy Physicians MG OON - CA": { payer: "Mercy Physicians", ipa: "Mercy Physicians" },
  "Merit Golden Coast MSO - CA": { payer: "Merit Golden Coast MSO", ipa: "Merit Golden Coast MSO" },
  "Meritain Health - CA": { payer: "Meritain Health", ipa: null },
  "Moda Health - CA": { payer: "Moda Health", ipa: null },
  "MOI WC - CA": { payer: "MOI WC", ipa: null },
  "Molina - CA": { payer: "Molina", ipa: null },
  "Molina MCR Adv - CA": { payer: "Molina", ipa: null },
  "Mountain Health Co-Op MCR Supp - CA": { payer: "Mountain Health Co-Op", ipa: null },
  "moviHealth - CA": { payer: "moviHealth", ipa: null },
  "MTI America WC (All Star) - CA": { payer: "MTI America WC", ipa: null },
  "Multiplan - CA": { payer: "Multiplan", ipa: null },
  "Mutual of Omaha MC Supp - CA": { payer: "Mutual of Omaha", ipa: null },
  "MVP Health Plan MCR Adv - CA": { payer: "MVP Health Plan", ipa: null },
  "NALC Health Benefit Plan Cigna - CA": { payer: "NALC Health Benefit Plan", ipa: null },
  "National Guardian Life MC Supp - CA": { payer: "National Guardian Life", ipa: null },
  "NECA/IBEW Family Med Care Plan - CA": {
    payer: "NECA/IBEW Family Med Care Plan",
    ipa: "NECA/IBEW Family Med Care Plan",
  },
  "NEIHBP MC Supp - CA": { payer: "NEIHBP", ipa: null },
  "NetWell (PHCS) - CA": { payer: "NetWell (PHCS)", ipa: null },
  "NeuroPraxis - CA": { payer: "NeuroPraxis", ipa: null },
  "New York City Employee PPO - CA": { payer: "New York City Employee PPO", ipa: null },
  "Next Level Admin WC - CA": { payer: "Next Level Admin WC", ipa: null },
  "Nippon Life Insurance - CA": { payer: "Nippon Life Insurance", ipa: null },
  "Nippon Life Insurance MC Supp - CA": { payer: "Nippon Life Insurance", ipa: null },
  "Northwest Administrators MCR Supp - CA": { payer: "Northwest Administrators", ipa: null },
  "NX Health Network - CA": { payer: "NX Health Network", ipa: null },
  "OCN - CA": { payer: "OCN", ipa: null },
  "OCN Applecare Select - CA": { payer: "OCN Applecare Select", ipa: null },
  "OCN Citrus Valley - CA": { payer: "OCN Citrus Valley", ipa: null },
  "OCN Corona - CA": { payer: "OCN Corona", ipa: "OCN Corona" },
  "OCN Corona Blue Shield - CA": { payer: "Blue Shield", ipa: "OCN Corona" },
  "OCN Desert Cities EPMG CAP - CA": { payer: "OCN Desert Cities EPMG", ipa: "OCN Desert Cities EPMG" },
  "OCN Desert Cities EPMG CAP -Aetna - CA": { payer: "Aetna", ipa: "OCN Desert Cities EPMG" },
  "OCN Desert Cities EPMG CAP Blue Cross - CA": { payer: "Blue Cross", ipa: "OCN Desert Cities EPMG" },
  "OCN Desert Cities EPMG CAP Blue Shield - CA": { payer: "Blue Shield", ipa: "OCN Desert Cities EPMG" },
  "OCN Desert Cities EPMG CAP Health Net - CA": { payer: "Health Net", ipa: "OCN Desert Cities EPMG" },
  "OCN Desert Cities EPMG CAP Humana - CA": { payer: "Humana", ipa: "OCN Desert Cities EPMG" },
  "OCN Desert Cities EPMG CAP SCAN - CA": { payer: "SCAN", ipa: "OCN Desert Cities EPMG" },
  "OCN Desert Cities EPMG CAP United healthcare - CA": { payer: "UHC", ipa: "OCN Desert Cities EPMG" },
  "OCN Desert Cities EPMG Carveout - CA": { payer: "OCN Desert Cities EPMG", ipa: "OCN Desert Cities EPMG" },
  "OCN Hemet Valley - CA": { payer: "OCN Hemet Valley", ipa: null },
  "OCN Inland Faculty MG - CA": { payer: "OCN Inland Faculty", ipa: "OCN Inland Faculty" },
  "OCN Inland Faculty MG - Humana - CA": { payer: "Humana", ipa: "OCN Inland Faculty" },
  "OCN Inland Faculty MG IEHP - CA": { payer: "IEHP", ipa: "OCN Inland Faculty" },
  "OCN Inland Faculty MG Molina - CA": { payer: "Molina", ipa: "OCN Inland Faculty" },
  "OCN Moreno Valley - CA": { payer: "OCN Moreno Valley", ipa: null },
  "OCN Redlands - CA": { payer: "OCN Redlands", ipa: "OCN Redlands" },
  "OCN Redlands United Healthcare - CA": { payer: "UHC", ipa: "OCN Redlands" },
  "OCN Southwestern Valleys Carve Out - CA": { payer: "OCN Southwestern Valleys", ipa: "OCN Southwestern Valleys" },
  "OCN Southwestern Valleys Carve Out Blue Cross - CA": { payer: "Blue Cross", ipa: "OCN Southwestern Valleys" },
  "OCN Southwestern Valleys Carve Out Blue Shield - CA": { payer: "Blue Shield", ipa: "OCN Southwestern Valleys" },
  "OCN Southwestern Valleys Carve Out SCAN - CA": { payer: "SCAN", ipa: "OCN Southwestern Valleys" },
  "OCN Southwestern Valleys Carve Out UHC - CA": { payer: "UHC", ipa: "OCN Southwestern Valleys" },
  "OCN Sun City Carveout - CA": { payer: "OCN Sun City", ipa: null },
  "OCN SW Valley FFS Eff 02/01/24 - CA": { payer: "OCN SW Valley", ipa: "OCN SW Valley" },
  "OCN SW Valleys Aetna - CA": { payer: "Aetna", ipa: "OCN SW Valleys" },
  "OCN SW Valleys Alignment - CA": { payer: "Alignment", ipa: "OCN SW Valleys" },
  "OCN SW Valleys Blue Cross - CA": { payer: "Blue Cross", ipa: "OCN SW Valleys" },
  "OCN SW Valleys Blue Cross MCR Adv - CA": { payer: "Blue Cross", ipa: "OCN SW Valleys" },
  "OCN SW Valleys Blue Shield - CA": { payer: "Blue Shield", ipa: "OCN SW Valleys" },
  "OCN SW Valleys Cigna - CA": { payer: "Cigna", ipa: "OCN SW Valleys" },
  "OCN SW Valleys Health Net - CA": { payer: "Health Net", ipa: "OCN SW Valleys" },
  "OCN SW Valleys Humana - CA": { payer: "Humana", ipa: "OCN SW Valleys" },
  "OCN SW Valleys IEHP - CA": { payer: "IEHP", ipa: "OCN SW Valleys" },
  "OCN SW Valleys SCAN - CA": { payer: "SCAN", ipa: "OCN SW Valleys" },
  "OCN SW Valleys UHC - CA": { payer: "UHC", ipa: "OCN SW Valleys" },
  "OCN/PRIMECARE/SAN BERNARDINO/FFS - CA": { payer: "OCN/PRIMECARE/SAN BERNARDINO", ipa: null },
  "Old Surety Life MCR Supp - CA": { payer: "Old Surety Life", ipa: null },
  "Omaha National WC - CA": { payer: "Omaha National WC", ipa: null },
  "One Call WC (All Star) - CA": { payer: "One Call WC", ipa: null },
  "One Call Work Conditioning - CA": { payer: "One Call", ipa: null },
  "One Share Health - CA": { payer: "One Share Health", ipa: null },
  "Onsite Physio WC - CA": { payer: "Onsite Physio WC", ipa: null },
  "Operating Engineers Local 302/612 - CA": { payer: "Operating Engineers Local 302/612", ipa: null },
  "OptiMed Health - CA": { payer: "OptiMed Health", ipa: null },
  "Optum WC (All Star) - CA": { payer: "Optum WC", ipa: null },
  "Optum-Beaver Medical Group/ Pinnacle Med Grp - CA": {
    payer: "Optum-Beaver Medical Group/ Pinnacle",
    ipa: "Optum-Beaver Medical Group/ Pinnacle",
  },
  "Orchid Medical WC - CA": { payer: "Orchid Medical WC", ipa: null },
  "Oxford Health Plans - CA": { payer: "Oxford Health Plans", ipa: null },
  "Pacific Claims Mgmt WC - CA": { payer: "Pacific Claims Mgmt WC", ipa: null },
  "Pacific Comp Ins WC - CA": { payer: "Pacific Comp Ins WC", ipa: null },
  "Pacific Source - CA": { payer: "Pacific Source", ipa: null },
  "Packard Claims Administration, Inc WC - CA": { payer: "Packard Claims Administration, Inc WC", ipa: null },
  "PAI - CA": { payer: "PAI", ipa: null },
  "Palo Alto Foundation Medical Group - CA": { payer: "Palo Alto Foundation", ipa: "Palo Alto Foundation" },
  "Palomar Health UMR - CA": { payer: "UMR", ipa: "UCSD" },
  "Paradigm WC - CA": { payer: "Paradigm WC", ipa: null },
  "Partnership Health Plan - CA": { payer: "Partnership Health Plan", ipa: null },
  "Payers Direct WC (All Star) - CA": { payer: "Payers WC", ipa: null },
  "PEHP MC Supp - CA": { payer: "PEHP", ipa: null },
  "Pending Insurance": { payer: "Pending Insurance", ipa: null },
  "Personify Health - CA": { payer: "Personify Health", ipa: null },
  "PHCS BAS - CA": { payer: "PHCS BAS", ipa: null },
  "Philadelphia American Life Insurance Company - CA": {
    payer: "Philadelphia American Life Insurance Company",
    ipa: null,
  },
  "Physician Health Network - CA": { payer: "Physician Health Network", ipa: "Physician Health Network" },
  "Physician Health Network IEHP - CA": { payer: "IEHP", ipa: "Physician Health Network" },
  "Physicians Mutual MCR Supp - CA": { payer: "Physicians Mutual", ipa: "Physicians Mutual" },
  "Physnet WC - CA": { payer: "Physnet WC", ipa: null },
  "PI Lien (PC) - CA": { payer: "PI Lien", ipa: null },
  "Pinnacle Claims Management - CA": { payer: "Pinnacle Claims Management", ipa: null },
  "Pitman Farms Work Comp - CA": { payer: "Pitman Farms Work Comp", ipa: null },
  "Point Comfort United MINOR - CA": { payer: "Point Comfort United MINOR", ipa: null },
  "Preferred Employers WC - CA": { payer: "Preferred Employers WC", ipa: null },
  "Preferred IPA MCD - CA": { payer: "Preferred IPA", ipa: "Preferred IPA" },
  "Premier Physicians Network (PTPN) - CA": { payer: "Premier Physicians Network", ipa: "Premier Physicians Network" },
  "Primary Care Assoc of CA (PCAC) - CA": { payer: "PCAC", ipa: "PCAC" },
  "Primary Care Assoc of CA (PCAC) Alignment- CA": { payer: "Alignment", ipa: "PCAC" },
  "Primary Care Assoc of CA (PCAC) Blue Cross - CA": { payer: "Blue Cross", ipa: "PCAC" },
  "Primary Care Assoc of CA (PCAC) Blue Cross MCR Adv- CA": { payer: "Blue Cross", ipa: "PCAC" },
  "Primary Care Assoc of CA (PCAC) Brand New Day - CA": { payer: "Brand New Day", ipa: "PCAC" },
  "Primary Care Assoc of CA (PCAC) Health Net - CA": { payer: "Health Net", ipa: "PCAC" },
  "Primary Care Assoc of CA (PCAC) Humana - CA": { payer: "Humana", ipa: "PCAC" },
  "Primary Care Assoc of CA (PCAC) -SCAN - CA": { payer: "SCAN", ipa: "PCAC" },
  "Primary Care Assoc of CA (PCAC) Wellcare - CA": { payer: "WellCare", ipa: "PCAC" },
  "Primetime Healthplan MC Supp - CA": { payer: "Primetime Healthplan", ipa: null },
  "Principal Life Ins MC Supp - CA": { payer: "Principal Life Ins", ipa: "Principal Life Ins" },
  "Priority Health - CA": { payer: "Priority Health", ipa: null },
  "PromiseCare Family Seniors Medical CAP - CA": { payer: "PromiseCare", ipa: "PromiseCare" },
  "PromiseCare Hemet CMG CAP - CA": { payer: "PromiseCare Hemet CMG", ipa: "PromiseCare Hemet CMG" },
  "PromiseCare Hemet CMG CAP SCAN - CA": { payer: "SCAN", ipa: "PromiseCare Hemet CMG" },
  "PromiseCare Hemet CMG CAP -UHC - CA": { payer: "UHC", ipa: "PromiseCare Hemet CMG" },
  "PromiseCare Menifee Valley CAP - Alignment - CA": { payer: "Alignment", ipa: "PromiseCare Menifee Valley" },
  "PromiseCare Menifee Valley CAP - CA": { payer: "PromiseCare Menifee Valley", ipa: "PromiseCare Menifee Valley" },
  "PromiseCare Menifee Valley CAP Blue Cross - CA": { payer: "Blue Cross", ipa: "PromiseCare Menifee Valley" },
  "PromiseCare Menifee Valley CAP SCAN - CA": { payer: "SCAN", ipa: "PromiseCare Menifee Valley" },
  "PromiseCare Menifee Valley CAP UHC - CA": { payer: "UHC", ipa: "PromiseCare Menifee Valley" },
  "PromiseCare Menifee Valley Med Grp CAP - CA": {
    payer: "PromiseCare Menifee Valley",
    ipa: "PromiseCare Menifee Valley",
  },
  "PromiseCare OOA": { payer: "PromiseCare", ipa: "PromiseCare" },
  "PromiseCare Tem Valley CAP - CA": { payer: "PromiseCare Tem Valley", ipa: "PromiseCare Tem Valley" },
  "PromiseCare Tem Valley CAP - HUMANA - CA": { payer: "Humana", ipa: "PromiseCare Tem Valley" },
  "PromiseCare Tem Valley CAP Aetna - CA": { payer: "Aetna", ipa: "PromiseCare Tem Valley" },
  "PromiseCare Tem Valley CAP -Alignment - CA": { payer: "Alignment", ipa: "PromiseCare Tem Valley" },
  "PromiseCare Tem Valley CAP Blue Cross - CA": { payer: "Blue Cross", ipa: "PromiseCare Tem Valley" },
  "PromiseCare Tem Valley CAP Blue Shield - CA": { payer: "Blue Shield", ipa: "PromiseCare Tem Valley" },
  "PromiseCare Tem Valley CAP Health Net - CA": { payer: "Health Net", ipa: "PromiseCare Tem Valley" },
  "PromiseCare Tem Valley CAP SCAN - CA": { payer: "SCAN", ipa: "PromiseCare Tem Valley" },
  "PromiseCare Tem Valley CAP UHC - CA": { payer: "UHC", ipa: "PromiseCare Tem Valley" },
  "PromiseCare Temecula Valley Phys CAP - CA": {
    payer: "PromiseCare Temecula Valley Phys",
    ipa: "PromiseCare Temecula Valley Phys",
  },
  "Providence–St Mary High Des OON - CA": { payer: "Providence–St Mary High Des", ipa: null },
  "Rady Children Commercial - CA": { payer: "Rady Children Commercial", ipa: "Rady Children Commercial" },
  "Rady Children Commercial Aetna - CA": { payer: "Aetna", ipa: "Rady Children Commercial" },
  "Rady Children Commercial Blue Cross - CA": { payer: "Blue Cross", ipa: "Rady Children Commercial" },
  "Rady Children Commercial Blue Shield - CA": { payer: "Blue Shield", ipa: "Rady Children Commercial" },
  "Rady Children Commercial Health Net - CA": { payer: "Health Net", ipa: "Rady Children Commercial" },
  "Rady Children Commercial Sharp Health - CA": { payer: "Sharp Health", ipa: "Rady Children Commercial" },
  "Rady Children Commercial UHC - CA": { payer: "UHC", ipa: "Rady Children Commercial" },
  "Rady Children Medical - CA": { payer: "Rady Children Medical", ipa: "Rady Children Medical" },
  "Rady Children Medical Blue Shield - CA": { payer: "Blue Shield", ipa: "Rady Children Medical" },
  "Rady Children Specialist - CA": { payer: "Rady Children Specialist", ipa: "Rady Children Specialist" },
  "Rady Children Specialist CHG - CA": { payer: "Community Health Group", ipa: "Rady Children Specialist" },
  "Rady Children Specialist Molina -  CA": { payer: "Molina", ipa: "Rady Children Specialist" },
  "Railroad Medicare - CA": { payer: "Railroad Medicare", ipa: null },
  "Red Rock Diagnostics - CA": { payer: "Red Rock Diagnostics", ipa: null },
  "Redwood Health Services (Aetna Supp) - CA": { payer: "Aetna", ipa: "Redwood Health Services" },
  "Reflect Health Commercial - CA": { payer: "Reflect Health Commercial", ipa: null },
  "Regal Aetna CAP - CA": { payer: "Aetna", ipa: "Regal CAP" },
  "Regal Aetna OOA - CA": { payer: "Aetna", ipa: "Regal OOA" },
  "Regal Alignment CAP - CA": { payer: "Alignment", ipa: "Regal CAP" },
  "Regal Alignment OOA - CA": { payer: "Alignment", ipa: "Regal OOA" },
  "Regal Anthem Blue Cross CAP - CA": { payer: "Anthem Blue Cross", ipa: "Regal CAP" },
  "Regal Anthem Blue Cross OOA - CA": { payer: "Anthem Blue Cross", ipa: "Regal OOA" },
  "Regal Astiva CAP - CA": { payer: "Astiva", ipa: "Regal CAP" },
  "Regal Astiva OOA - CA": { payer: "Astiva", ipa: "Regal OOA" },
  "Regal Blue Shield CAP - CA": { payer: "Blue Shield", ipa: "Regal CAP" },
  "Regal Blue Shield OOA - CA": { payer: "Blue Shield", ipa: "Regal OOA" },
  "Regal Cal Optima CAP - CA": { payer: "Cal Optima", ipa: "Regal CAP" },
  "Regal Cal Optima OOA - CA": { payer: "Cal Optima", ipa: "Regal OOA" },
  "Regal Central Health Plan-CAP - CA": { payer: "Central Health Plan", ipa: "Regal CAP" },
  "Regal Central Health Plan-OOA - CA": { payer: "Central Health Plan", ipa: "Regal OOA" },
  "Regal Cigna CAP - CA": { payer: "Cigna", ipa: "Regal CAP" },
  "Regal Cigna Net OOA - CA": { payer: "Cigna", ipa: "Regal OOA" },
  "Regal Easy Choice CAP - CA": { payer: "Easy Choice", ipa: "Regal CAP" },
  "Regal Easy Choice OOA - CA": { payer: "Easy Choice", ipa: "Regal OOA" },
  "Regal Health Net CAP - CA": { payer: "Health Net", ipa: "Regal CAP" },
  "Regal Health Net OOA - CA": { payer: "Health Net", ipa: "Regal OOA" },
  "Regal Heritage Phys Network OOA - CA": { payer: "Heritage Phys Network", ipa: "Regal OOA" },
  "Regal Humana CAP - CA": { payer: "Humana", ipa: "Regal CAP" },
  "Regal Humana OOA - CA": { payer: "Humana", ipa: "Regal OOA" },
  "Regal IEHP CAP - CA": { payer: "IEHP", ipa: "Regal CAP" },
  "Regal IEHP OOA - CA": { payer: "IEHP", ipa: "Regal OOA" },
  "Regal Imperial Health CAP - CA": { payer: "Imperial Health", ipa: "Regal CAP" },
  "Regal Imperial Health OOA - CA": { payer: "Imperial Health", ipa: "Regal OOA" },
  "Regal Molina CAP - CA": { payer: "Molina", ipa: "Regal CAP" },
  "Regal Molina OOA - CA": { payer: "Molina", ipa: "Regal OOA" },
  "Regal Pacificare CAP - CA": { payer: "Pacificare", ipa: "Regal CAP" },
  "Regal Pacificare OOA - CA": { payer: "Pacificare", ipa: "Regal OOA" },
  "Regal SCAN CAP - CA": { payer: "SCAN", ipa: "Regal CAP" },
  "Regal SCAN OOA - CA": { payer: "SCAN", ipa: "Regal OOA" },
  "Regal Secure Horizons CAP - CA": { payer: "Secure Horizons", ipa: "Regal CAP" },
  "Regal Secure Horizons OOA - CA": { payer: "Secure Horizons", ipa: "Regal OOA" },
  "Regal UHC CAP - CA": { payer: "UHC", ipa: "Regal CAP" },
  "Regal UHC OOA - CA": { payer: "UHC", ipa: "Regal OOA" },
  "Regal Wellcare CAP - CA": { payer: "Wellcare", ipa: "Regal CAP" },
  "Regal Wellcare OOA - CA": { payer: "Wellcare", ipa: "Regal OOA" },
  "Republic Indemnity WC - CA": { payer: "Republic Indemnity WC", ipa: null },
  "Rios Southwest Med Grp - CA": { payer: "Rios Southwest", ipa: "Rios Southwest" },
  "Rios Southwest Med Grp Alignment - CA": { payer: "Alignment", ipa: "Rios Southwest" },
  "Rios Southwest Med Grp Brand New Day - CA": { payer: "Brand New Day", ipa: "Rios Southwest" },
  "Rios Southwest Med Grp SCAN - CA": { payer: "SCAN", ipa: "Rios Southwest" },
  "Riverside Medical Clinic - CA": { payer: "Riverside Medical Clinic", ipa: "Riverside Medical Clinic" },
  "Riverside Medical Clinic Aetna - CA": { payer: "Aetna", ipa: "Riverside Medical Clinic" },
  "Riverside Medical Clinic Alignment - CA": { payer: "Alignment", ipa: "Riverside Medical Clinic" },
  "Riverside Medical Clinic Blue Cross - CA": { payer: "Blue Cross", ipa: "Riverside Medical Clinic" },
  "Riverside Medical Clinic Blue Cross MCR Adv - CA": { payer: "Blue Cross", ipa: "Riverside Medical Clinic" },
  "Riverside Medical Clinic Blue Shield - CA": { payer: "Blue Shield", ipa: "Riverside Medical Clinic" },
  "Riverside Medical Clinic Central Health - CA": { payer: "Central Health", ipa: "Riverside Medical Clinic" },
  "Riverside Medical Clinic Cigna - CA": { payer: "Cigna", ipa: "Riverside Medical Clinic" },
  "Riverside Medical Clinic Health Net - CA": { payer: "Health Net", ipa: "Riverside Medical Clinic" },
  "Riverside Medical Clinic Humana - CA": { payer: "Humana", ipa: "Riverside Medical Clinic" },
  "Riverside Medical Clinic SCAN - CA": { payer: "SCAN", ipa: "Riverside Medical Clinic" },
  "Riverside Medical Clinic UHC - CA": { payer: "UHC", ipa: "Riverside Medical Clinic" },
  "Robin Assist - CA": { payer: "Robin Assist", ipa: null },
  "ROJW-Health Care Support - CA": { payer: "ROJW-Health Care Support", ipa: null },
  "SAIF Work Comp - CA": { payer: "SAIF Work Comp", ipa: null },
  "SAMBA - CA": { payer: "SAMBA", ipa: null },
  "San Bernardino County WC - CA": { payer: "San Bernardino County WC", ipa: null },
  "San Diego Mesa College - CA": { payer: "San Diego Mesa College", ipa: null },
  "Sanford Health Plan - CA": { payer: "Sanford Health Plan", ipa: null },
  "Santa Fe Employes Hospital Assoc - CA": { payer: "Santa Fe Employes Hospital Assoc", ipa: null },
  "SBMA - CA": { payer: "SBMA", ipa: null },
  "Scan Health Plan - CA": { payer: "SCAN", ipa: null },
  "SCMG Graybill (FFS) - CA": { payer: "SCMG Graybill", ipa: "SCMG Graybill" },
  "SCMG Graybill (FFS) Aetna - CA": { payer: "Aetna", ipa: "SCMG Graybill" },
  "SCMG Graybill (FFS) Blue Cross - CA": { payer: "Blue Cross", ipa: "SCMG Graybill" },
  "SCMG Graybill (FFS) Blue Cross MCR Adv - CA": { payer: "Blue Cross", ipa: "SCMG Graybill" },
  "SCMG Graybill (FFS) Cigna - CA": { payer: "Cigna", ipa: "SCMG Graybill" },
  "SCMG Graybill (FFS) Health Net - CA": { payer: "Health Net", ipa: "SCMG Graybill" },
  "SCMG Graybill (FFS) Sharp Health - CA": { payer: "Sharp Health", ipa: "SCMG Graybill" },
  "SCMG Graybill (FFS) UHC - CA": { payer: "UHC", ipa: "SCMG Graybill" },
  "SCMG Graybill (FFS)(After 6/1/23) - CA": { payer: "SCMG Graybill", ipa: "SCMG Graybill" },
  "SCMG Graybill CAP - CA": { payer: "SCMG Graybill", ipa: "SCMG Graybill" },
  "Scripps Coastal Medical Group - CA": { payer: "Scripps Coastal", ipa: "Scripps Coastal" },
  "Scripps Coastal Medical Group AETNA - CA": { payer: "Aetna", ipa: "Scripps Coastal" },
  "Scripps Coastal Medical Group Alignment - CA": { payer: "Alignment", ipa: "Scripps Coastal" },
  "Scripps Coastal Medical Group Blue Cross - CA": { payer: "Blue Cross", ipa: "Scripps Coastal" },
  "Scripps Coastal Medical Group Blue Cross MCR Adv- CA": { payer: "Blue Cross", ipa: "Scripps Coastal" },
  "Scripps Coastal Medical Group Blue Shield - CA": { payer: "Blue Shield", ipa: "Scripps Coastal" },
  "Scripps Coastal Medical Group Cigna - CA": { payer: "Cigna", ipa: "Scripps Coastal" },
  "Scripps Coastal Medical Group Health Net - CA": { payer: "Health Net", ipa: "Scripps Coastal" },
  "Scripps Coastal Medical Group UHC - CA": { payer: "UHC", ipa: "Scripps Coastal" },
  "Scripps Health Plan Hmo - CA": { payer: "Scripps Health Plan Hmo", ipa: null },
  "Secure Horizons MC Supp - CA": { payer: "Secure Horizons", ipa: null },
  "Sedgwick Unit C WC - CA": { payer: "Sedgwick Unit C WC", ipa: null },
  "Sedgwick Unit D WC -CA": { payer: "Sedgwick Unit D WC", ipa: null },
  "Sedgwick WC - CA": { payer: "Sedgwick WC", ipa: null },
  "Self Insured Services Company (SISCO) - CA": { payer: "Self Insured Services Company (SISCO)", ipa: null },
  "Self Pay": { payer: "Self Pay", ipa: null },
  "Selman & Co - CA": { payer: "Selman & Co", ipa: null },
  "Sempra Energy / SDG&E Work Comp - CA": { payer: "Sempra Energy / SDG&E Work Comp", ipa: null },
  "Seoul Medical Group - CA": { payer: "Seoul", ipa: "Seoul" },
  "Set Comprehensive Care WC - CA": { payer: "Set Comprehensive Care WC", ipa: null },
  "Sharp Health Plan - CA": { payer: "Sharp Health", ipa: null },
  "Sierra Health And Life MC Supp - CA": { payer: "Sierra Health And Life", ipa: null },
  "Signal Mutual Work Comp - CA": { payer: "Signal Mutual Work Comp", ipa: null },
  "Simple MSK / Physmetrics - CA": { payer: "Simple MSK / Physmetrics", ipa: null },
  "Solidarity Healthshare - CA": { payer: "Solidarity Healthshare", ipa: null },
  "Sound Health/Freedom Physician - CA": {
    payer: "Sound Health/Freedom Physician",
    ipa: "Sound Health/Freedom Physician",
  },
  "Southcoast WC - CA": { payer: "Southcoast WC", ipa: null },
  "Southern CA Edison WC - CA": { payer: "Southern CA Edison WC", ipa: null },
  "Southern CA Lumber Ind - CA": { payer: "Southern CA Lumber Ind", ipa: null },
  "Southern California UFCW & Food Employees - CA": { payer: "Southern California UFCW & Food Employees", ipa: null },
  "Special Risk Mutual of Omaha WC - CA": { payer: "Special Risk Mutual of Omaha WC", ipa: null },
  "SPNET WC - CA": { payer: "SPNET WC", ipa: null },
  "St Lukes Health Plan - CA": { payer: "St Lukes Health Plan", ipa: null },
  "Standard Life & Accident Ins - CA": { payer: "Standard Life & Accident Ins", ipa: null },
  "State Comp Ins Fund WC - CA": { payer: "State Comp Ins Fund WC", ipa: null },
  "State Farm Health - CA": { payer: "State Farm Health", ipa: null },
  "State Farm MC Supp - CA": { payer: "State Farm", ipa: null },
  "State Farm MVA - CA": { payer: "State Farm", ipa: null },
  "Strategic Comp - CA": { payer: "Strategic Comp", ipa: null },
  "STREAMLINE PT WC - CA": { payer: "STREAMLINE PT WC", ipa: null },
  "Student Health Claims Department BC - CA": { payer: "Student Health Claims Department BC", ipa: null },
  "SummaCare Health Plan - CA": { payer: "SummaCare Health Plan", ipa: null },
  "Surest - CA": { payer: "Surest", ipa: null },
  "Syndeocare/Movedocs - CA": { payer: "Syndeocare/Movedocs", ipa: null },
  "Teamsters MC Supp - CA": { payer: "Teamsters", ipa: null },
  "Temecula Valley School District ST Only": { payer: "Temecula Valley School District ST Only", ipa: null },
  "The Fairly Group WC - CA": { payer: "The Fairly Group WC", ipa: null },
  "The Hartford WC - CA": { payer: "The Hartford WC", ipa: null },
  "The Health Plan - CA": { payer: "The Health Plan", ipa: null },
  "The Macy's Plan MC Supp - CA": { payer: "The Macy's Plan", ipa: null },
  "The Polaris Group WC - CA": { payer: "The Polaris Group WC", ipa: null },
  "The Walt Disney Co WC - CA": { payer: "The Walt Disney Co WC", ipa: null },
  "Therapy Direct WC (All Star) - CA": { payer: "Therapy WC", ipa: null },
  "THM WC - CA": { payer: "THM WC", ipa: null },
  "Thrivent - CA": { payer: "Thrivent", ipa: null },
  "Tokio Marine Mgt Work Comp - CA": { payer: "Tokio Marine Mgt Work Comp", ipa: null },
  "Total Network Rscs WC - CA": { payer: "Total Network Rscs WC", ipa: null },
  "Transamerica Life (First Health Network) - CA": { payer: "Transamerica Life (First Health Network)", ipa: null },
  "Transamerican Life MC Supp - CA": { payer: "Transamerican Life", ipa: null },
  "Transwestern - CA": { payer: "Transwestern", ipa: null },
  "Travelers WC - CA": { payer: "Travelers WC", ipa: null },
  "Tribal First WC - CA": { payer: "Tribal First WC", ipa: null },
  "Tricare For Life - CA": { payer: "Tricare", ipa: null },
  "Tricare Overseas - CA": { payer: "Tricare", ipa: null },
  "Tricare West - CA": { payer: "Tricare", ipa: null },
  "Triflex Care, LLC WC - CA": { payer: "Triflex Care, LLC WC", ipa: null },
  "Trivalley Med Grp Aetna OON - CA": { payer: "Aetna", ipa: "Trivalley" },
  "Trivalley Med Grp Blue Cross OON - CA": { payer: "Blue Cross", ipa: "Trivalley" },
  "Trivalley Med Grp Blue Cross OON MCR Adv - CA": { payer: "Blue Cross", ipa: "Trivalley" },
  "Trivalley Med Grp Health Net OON - CA": { payer: "Health Net", ipa: "Trivalley" },
  "Trivalley Med Grp OON - CA": { payer: "Trivalley", ipa: "Trivalley" },
  "Trivalley Med Grp SCAN OON - CA": { payer: "SCAN", ipa: "Trivalley" },
  "Trustmark Health - CA": { payer: "Trustmark Health", ipa: null },
  "Tufts Health Plan – Carelink - CA": { payer: "Tufts Health Plan – Carelink", ipa: null },
  "U of A Claims - CA": { payer: "U of A Claims", ipa: null },
  "UCLA Medical Group - CA": { payer: "UCLA", ipa: "UCLA" },
  "UCSD Healthcare Network - CA": { payer: "UCSD", ipa: "UCSD" },
  "UCSD Healthcare Network Aetna - CA": { payer: "Aetna", ipa: "UCSD" },
  "UCSD Healthcare Network Blue Cross - CA": { payer: "Blue Cross", ipa: "UCSD" },
  "UCSD Healthcare Network Blue Cross MCR Adv - CA": { payer: "Blue Cross", ipa: "UCSD" },
  "UCSD Healthcare Network Blue Shield - CA": { payer: "Blue Shield", ipa: "UCSD" },
  "UCSD Healthcare Network Health Net - CA": { payer: "Health Net", ipa: "UCSD" },
  "UCSD Healthcare Network Humana - CA": { payer: "Humana", ipa: "UCSD" },
  "UCSD Healthcare Network SCAN - CA": { payer: "SCAN", ipa: "UCSD" },
  "UCSD Healthcare Network United Healthcare - CA": { payer: "UHC", ipa: "UCSD" },
  "UHSM - CA": { payer: "UHSM", ipa: null },
  "UHSM WeShare - CA": { payer: "UHSM WeShare", ipa: null },
  "UMR - CA": { payer: "UMR", ipa: null },
  "UniCare - CA": { payer: "UniCare", ipa: null },
  "Unified Life Ins Co - CA": { payer: "Unified Life Ins Co", ipa: null },
  "Unified Life Ins Co MC Supp - CA": { payer: "Unified Life Ins Co", ipa: null },
  "United American MC Supp - CA": { payer: "United American", ipa: null },
  "United Healthcare - CA": { payer: "UHC", ipa: null },
  "United Healthcare MCR ADV - CA": { payer: "UHC", ipa: null },
  "United Healthcare Shared Services - CA": { payer: "UHC", ipa: null },
  "United Healthcare Student Resources - CA": { payer: "UHC", ipa: null },
  "United World MC Supp - CA": { payer: "United World", ipa: null },
  "UnitedHealthOne - CA": { payer: "UnitedHealthOne", ipa: null },
  "Univ of San Diego / JCP Athletic Secondary Ins - CA": { payer: "Univ of San Diego / JCP Athletic Ins", ipa: null },
  "UPMC MC Supp - CA": { payer: "UPMC", ipa: null },
  "US Department Of Labor WC - CA": { payer: "US Department Of Labor WC", ipa: null },
  "US Network and Administrative Services - CA": { payer: "US Network and Administrative Services", ipa: null },
  "USAA MC Supp - CA": { payer: "USAA", ipa: null },
  "USAA MVA - CA": { payer: "USAA", ipa: null },
  "USC Care  Athletics - CA": { payer: "USC Care Athletics", ipa: null },
  "VA CCN - CA": { payer: "VA CCN", ipa: null },
  "Vantage/Prospect Med Grp  Aetna - CA": { payer: "Aetna", ipa: "Vantage/Prospect" },
  "Vantage/Prospect Med Grp - CA": { payer: "Vantage/Prospect", ipa: "Vantage/Prospect" },
  "Vantage/Prospect Med Grp -Blue Cross - CA": { payer: "Blue Cross", ipa: "Vantage/Prospect" },
  "Vantage/Prospect Med Grp Blue Cross MCR Adv - CA": { payer: "Blue Cross", ipa: "Vantage/Prospect" },
  "Vantage/Prospect Med Grp Blue Shield - CA": { payer: "Blue Shield", ipa: "Vantage/Prospect" },
  "Vantage/Prospect Med Grp Brand New Day - CA": { payer: "Brand New Day", ipa: "Vantage/Prospect" },
  "Vantage/Prospect Med Grp Health Net - CA": { payer: "Health Net", ipa: "Vantage/Prospect" },
  "Vantage/Prospect Med Grp Humana - CA": { payer: "Humana", ipa: "Vantage/Prospect" },
  "Vantage/Prospect Med Grp Molina - CA": { payer: "Molina", ipa: "Vantage/Prospect" },
  "Vantage/Prospect Med Grp SCAN - CA": { payer: "SCAN", ipa: "Vantage/Prospect" },
  "Verdegard Adminstrators - CA": { payer: "Verdegard Adminstrators", ipa: null },
  "Victori Health - CA": { payer: "Victori Health", ipa: null },
  "Village Health - CA": { payer: "Village Health", ipa: null },
  "WA Dept Of Labor & Ind WC - CA": { payer: "WA Dept Of Labor & Ind WC", ipa: null },
  "Washington National MC Supp - ID": { payer: "Washington National", ipa: null },
  "Watts Health Care - CA": { payer: "Watts Health Care", ipa: null },
  "Wawanesa MVA - CA": { payer: "Wawanesa", ipa: null },
  "WebTPA - CA": { payer: "WebTPA", ipa: null },
  "WellCare - CA": { payer: "WellCare", ipa: null },
  "Wellfleet Student Group - CA": { payer: "Wellfleet Student Group", ipa: null },
  "Wellpoint - CA": { payer: "Wellpoint", ipa: null },
  "Western & Southern Financial Group - CA": { payer: "Western & Southern Financial Group", ipa: null },
  "Western Growers Assurance Trust - CA": { payer: "Western Growers Assurance Trust", ipa: null },
  "Workers Compensation Fund WC - CA": { payer: "Workers Compensation Fund WC", ipa: null },
  "WPS MC Supp - CA": { payer: "WPS", ipa: null },
  "Zurich WC - CA": { payer: "Zurich WC", ipa: null },
};

const normalizeInsuranceKey = (name: string): string => name.replace(/\s+/g, " ").trim().toLowerCase();

const LOOKUP_BY_NORMALIZED_NAME = new Map<string, InsurancePayerIpa>(
  Object.entries(CONFLUENT_INSURANCE_PAYER_IPA).map(([name, value]) => [normalizeInsuranceKey(name), value])
);

export function lookupConfluentInsurancePayerAndIpa(
  insuranceName: string | null | undefined
): InsurancePayerIpa | null {
  if (!insuranceName) return null;

  return LOOKUP_BY_NORMALIZED_NAME.get(normalizeInsuranceKey(insuranceName)) ?? null;
}

const CONFLUENT_NONE_LISTED_PAYER = "None Listed";

export function isConfluentNoneListedPayer(payerName: string | null | undefined): boolean {
  return !!payerName && normalizeInsuranceKey(payerName) === normalizeInsuranceKey(CONFLUENT_NONE_LISTED_PAYER);
}

// Static primaryEhrPayerName options in blocks.yaml that don't name a Clinicient insurance plan.
const CONFLUENT_NON_PLAN_PAYERS = new Set(
  [CONFLUENT_NONE_LISTED_PAYER, "Other", "Scripps Physician Medical Group", "Sharp Rees-Stealy"].map(
    normalizeInsuranceKey
  )
);

export function isConfluentNonPlanPayer(payerName: string | null | undefined): boolean {
  return !!payerName && CONFLUENT_NON_PLAN_PAYERS.has(normalizeInsuranceKey(payerName));
}
